export const spfColor = {
  gray200: '#E4E7EC',
};
